import ConsumerDetail from "./consumerDetails.container"

export default ConsumerDetail